import type { LayoutConfig, Slot } from "./layout-config";
import { hasMetadataSplitLayout } from "./split-layout";

type ToeicLayoutItem = {
	recordType?: string;
	metadata?: {
		uiRendering?: {
			splitLayout?: boolean;
		};
	};
};

type GetToeicRenderingLayoutParams = {
	item: ToeicLayoutItem;
	isSplitLayout: boolean;
	layoutConfig: LayoutConfig;
	forceStacked?: boolean;
};

const ITEM_MEDIA_SLOTS = new Set<Slot>(["item_audio", "item_image"]);
const STIMULUS_SLOT: Slot = "stimulus";
const QUESTION_INSTRUCTION_SLOT: Slot = "question_instruction";

const withoutLeftPanelSlots = (slots: Slot[]) =>
	slots.filter(
		(slot) => !ITEM_MEDIA_SLOTS.has(slot) && slot !== QUESTION_INSTRUCTION_SLOT,
	);

export const getToeicRenderingLayout = ({
	item,
	isSplitLayout,
	layoutConfig,
	forceStacked,
}: GetToeicRenderingLayoutParams) => {
	const metadataSplitLayout = hasMetadataSplitLayout(item);
	const shouldRenderItemMediaInLeftPanel = metadataSplitLayout;

	const panelLayoutConfig = shouldRenderItemMediaInLeftPanel
		? {
				...layoutConfig,
				left: [
					QUESTION_INSTRUCTION_SLOT,
					STIMULUS_SLOT,
					...layoutConfig.left.filter(
						(slot) =>
							slot !== QUESTION_INSTRUCTION_SLOT && slot !== STIMULUS_SLOT,
					),
				],
				right: withoutLeftPanelSlots(layoutConfig.right),
			}
		: layoutConfig;

	if (forceStacked) {
		return {
			effectiveSplitLayout: false,
			layoutConfig: {
				...panelLayoutConfig,
				stacked: [
					...panelLayoutConfig.left,
					...panelLayoutConfig.right.filter(
						(slot) => !panelLayoutConfig.left.includes(slot),
					),
				],
			},
			shouldRenderItemMediaInLeftPanel,
		};
	}

	return {
		effectiveSplitLayout:
			isSplitLayout || item.recordType === "SCENARIO" || metadataSplitLayout,
		layoutConfig: panelLayoutConfig,
		shouldRenderItemMediaInLeftPanel,
	};
};
